module.exports = __webpack_public_path__ + "images/lab/project-list-view-322563ee927c1b1468314b82912e964a.jpg";